import { Room } from '../types';

export const ROOMS: Record<string, Room> = {
  classroom: {
    id: 'classroom',
    name: '教室 2-B',
    description: '埃っぽい教室。黒板には何かが書かれている。窓の外は真っ暗だ。',
    floor: 1,
    bgColor: '#1a1a2e',
    bgPattern: 'classroom',
    bgImage: '/images/教室2-B.png',
    hotspots: [
      {
        id: 'blackboard',
        x: 32,
        y: 20,
        width: 38,
        height: 28,
        label: '黒板',
        puzzleId: 'blackboard_cipher',
        description: '黒板にチョークで数字が書かれている。\n「5-2  11-4  9-5」\nその下に薄く五十音表が描かれている。濁音の行も含まれているようだ。',
      },
      {
        id: 'locker_row',
        x: 0,
        y: 28,
        width: 18,
        height: 62,
        label: 'ロッカー',
        puzzleId: 'locker_search',
        description: 'ずらりと並んだロッカー。ほとんどは空だが、一つだけ何かが入っているようだ。',
        interactedDescription: '空のロッカー。もう何もない。',
      },
      {
        id: 'classroom_desk',
        x: 20,
        y: 50,
        width: 55,
        height: 42,
        label: '机',
        description: '並んだ机。一つの机の表面に爪で引っ掻いたような文字がある。\n「たすけて」',
        itemReward: 'diary_fragment_1',
      },
      {
        id: 'classroom_door',
        x: 79,
        y: 15,
        width: 13,
        height: 65,
        label: '廊下へ',
        targetRoom: 'hallway_1f',
        description: '教室のドア。廊下に出られる。',
      },
    ],
    horrorEvents: [
      {
        id: 'classroom_enter_1',
        trigger: 'enter',
        type: 'text',
        content: '……ここは、どこだ？\n頭がぼんやりする。なぜ自分はここにいるんだろう。',
        duration: 4000,
        oneShot: true,
      },
      {
        id: 'classroom_whisper',
        trigger: 'time',
        triggerValue: 30000,
        type: 'text',
        content: '（……どこかから、かすかな声が聞こえた気がする）',
        duration: 3000,
        oneShot: true,
      },
    ],
  },

  hallway_1f: {
    id: 'hallway_1f',
    name: '1階 廊下',
    description: '薄暗い廊下。非常灯だけがぼんやりと光っている。',
    floor: 1,
    bgColor: '#16213e',
    bgPattern: 'hallway',
    bgImage: '/images/1階廊下.jpg',
    hotspots: [
      {
        id: 'hw1_to_classroom',
        x: 10,
        y: 20,
        width: 12,
        height: 65,
        label: '教室',
        targetRoom: 'classroom',
        description: '教室 2-Bへの入口。',
      },
      {
        id: 'hw1_to_staffroom',
        x: 28,
        y: 25,
        width: 14,
        height: 55,
        label: '職員室',
        targetRoom: 'staffroom',
        requiredItem: 'staffroom_key',
        description: '職員室のドア。鍵がかかっている。',
        interactedDescription: '職員室のドア。鍵は開いている。',
      },
      {
        id: 'hw1_to_infirmary',
        x: 62,
        y: 20,
        width: 16,
        height: 60,
        label: '保健室',
        targetRoom: 'infirmary',
        description: '保健室のドア。開いている。',
      },
      {
        id: 'hw1_stairs_up',
        x: 82,
        y: 15,
        width: 16,
        height: 75,
        label: '階段（2F）',
        targetRoom: 'hallway_2f',
        description: '2階への階段。',
      },
    ],
    horrorEvents: [
      {
        id: 'hallway1_footsteps',
        trigger: 'enter',
        type: 'text',
        content: '（……廊下の奥から、足音が聞こえた気がする）',
        duration: 3000,
        oneShot: true,
      },
    ],
  },

  staffroom: {
    id: 'staffroom',
    name: '職員室',
    description: '散乱した書類。机の上にコーヒーカップが残されている。まだ微かに温かい……？',
    floor: 1,
    bgColor: '#1a1a2e',
    bgPattern: 'staffroom',
    bgImage: '/images/職員室.jpg',
    requiredKey: 'staffroom_key',
    hotspots: [
      {
        id: 'staff_drawers',
        x: 14,
        y: 65,
        width: 42,
        height: 10,
        label: '引き出し',
        puzzleId: 'drawer_logic',
        description: '5つの引き出しがある大きな机。\nメモが貼ってある：\n「Aの右隣にBはない」\n「Cは端にある」\n「目的のものはCの隣にある」\n「DはBより左」',
      },
      {
        id: 'staff_roster',
        x: 62,
        y: 10,
        width: 20,
        height: 45,
        label: '書棚',
        puzzleId: 'roster_search',
        description: '生徒名簿や記録が並んでいる。「2年B組」のファイルが目に入る。',
      },
      {
        id: 'staff_papers',
        x: 2,
        y: 78,
        width: 12,
        height: 14,
        label: '散らばった書類',
        description: '机の上に散らばった書類の中に、モールス信号の変換表が混じっている。\n授業の教材だったのだろうか。',
        itemReward: 'morse_chart',
      },
      {
        id: 'staff_photo',
        x: 69,
        y: 60,
        width: 11,
        height: 18,
        label: '写真',
        description: '床に立てかけられた集合写真。',
        itemReward: 'old_photograph',
      },
      {
        id: 'staff_door',
        x: 84,
        y: 15,
        width: 14,
        height: 75,
        label: '廊下へ',
        targetRoom: 'hallway_1f',
        description: '廊下に戻る。',
      },
    ],
    horrorEvents: [
      {
        id: 'staff_coffee',
        trigger: 'enter',
        type: 'text',
        content: '（コーヒーカップに触れると……温かい。誰かがつい最近までここにいた？）',
        duration: 4000,
        oneShot: true,
      },
    ],
  },

  infirmary: {
    id: 'infirmary',
    name: '保健室',
    description: 'カーテンで仕切られたベッドが並ぶ。消毒液の匂いがかすかに残っている。',
    floor: 1,
    bgColor: '#1a2a1a',
    bgPattern: 'infirmary',
    bgImage: '/images/保健室.jpg',
    hotspots: [
      {
        id: 'medicine_cabinet',
        x: 2,
        y: 25,
        width: 24,
        height: 35,
        label: '薬棚',
        puzzleId: 'medicine_dial',
        description: '施錠された薬棚。4桁のダイヤルロック。\n棚の横にカルテが挟まっている。\n日付: XX月03日\n体温: XX.6℃\n※一部の数字が汚れて読めない。別の場所にヒントがあるかもしれない。',
      },
      {
        id: 'infirmary_bed',
        x: 45,
        y: 15,
        width: 38,
        height: 65,
        label: 'ベッド',
        description: 'カーテンの奥のベッド。枕の下に何かがある。',
        itemReward: 'diary_fragment_2',
      },
      {
        id: 'infirmary_desk',
        x: 2,
        y: 62,
        width: 30,
        height: 35,
        label: '保健室の机',
        description: '養護教諭の机。引き出しの中にカルテの控えがある。\n「水無月詩織 - 09月03日 来室\n体温: 36.6℃\n症状: 頭痛、食欲不振\n備考: 精神的な問題の可能性あり。要観察」',
      },
      {
        id: 'infirmary_door',
        x: 85,
        y: 20,
        width: 13,
        height: 65,
        label: '廊下へ',
        targetRoom: 'hallway_1f',
        description: '廊下に戻る。',
      },
    ],
    horrorEvents: [
      {
        id: 'infirmary_curtain',
        trigger: 'time',
        triggerValue: 20000,
        type: 'screen_effect',
        content: 'flicker',
        duration: 2000,
        oneShot: true,
      },
    ],
  },

  hallway_2f: {
    id: 'hallway_2f',
    name: '2階 廊下',
    description: '2階の廊下。壁の掲示物が色褪せている。',
    floor: 2,
    bgColor: '#1e1e3a',
    bgPattern: 'hallway',
    bgImage: '/images/2階廊下.jpg',
    hotspots: [
      {
        id: 'hw2_to_music',
        x: 8,
        y: 15,
        width: 18,
        height: 68,
        label: '音楽室',
        targetRoom: 'music_room',
        requiredItem: 'music_room_key',
        description: '音楽室のドア。鍵がかかっている。',
        interactedDescription: '音楽室のドア。鍵は開いている。',
      },
      {
        id: 'hw2_to_library',
        x: 27,
        y: 20,
        width: 9,
        height: 55,
        label: '図書室',
        targetRoom: 'library',
        description: '図書室のドア。開いている。',
      },
      {
        id: 'hw2_stairs_down',
        x: 80,
        y: 70,
        width: 18,
        height: 15,
        label: '階段（1F）',
        targetRoom: 'hallway_1f',
        description: '1階への階段。',
      },
      {
        id: 'hw2_stairs_up',
        x: 80,
        y: 5,
        width: 18,
        height: 62,
        label: '階段（3F）',
        targetRoom: 'hallway_3f',
        requiredItem: 'floor3_key',
        description: '3階への階段。鎖と鍵で封鎖されている。',
        interactedDescription: '3階への階段。鎖は外れている。',
      },
    ],
    horrorEvents: [
      {
        id: 'hw2_shadow',
        trigger: 'enter',
        type: 'text',
        content: '（廊下の突き当たりに、人影が見えた気がした……振り返ると、誰もいない）',
        duration: 4000,
        oneShot: true,
      },
    ],
  },

  music_room: {
    id: 'music_room',
    name: '音楽室',
    description: '大きなグランドピアノが置かれた音楽室。壁には作曲家の肖像画が並んでいる。',
    floor: 2,
    bgColor: '#2a1a2e',
    bgPattern: 'music',
    bgImage: '/images/音楽室.jpg',
    requiredKey: 'music_room_key',
    hotspots: [
      {
        id: 'piano',
        x: 25,
        y: 25,
        width: 40,
        height: 55,
        label: 'ピアノ',
        puzzleId: 'piano_sequence',
        description: 'グランドピアノ。蓋は開いている。鍵盤を弾くことができそうだ。\n楽譜立てに「この曲を正しく弾いてください」と書かれたメモがある。',
      },
      {
        id: 'music_shelf',
        x: 0,
        y: 10,
        width: 15,
        height: 75,
        label: '楽譜棚',
        description: '楽譜が並んでいる。一冊の楽譜の間に破れたページが挟まっていた。',
        itemReward: 'torn_sheet_music_1',
      },
      {
        id: 'music_locker',
        x: 70,
        y: 15,
        width: 13,
        height: 65,
        label: 'ロッカー',
        description: '楽器用のロッカー。中に破れた楽譜の一部がある。',
        itemReward: 'torn_sheet_music_2',
      },
      {
        id: 'music_door',
        x: 85,
        y: 15,
        width: 13,
        height: 70,
        label: '廊下へ',
        targetRoom: 'hallway_2f',
        description: '廊下に戻る。',
      },
    ],
    horrorEvents: [
      {
        id: 'music_auto_play',
        trigger: 'time',
        triggerValue: 45000,
        type: 'text',
        content: '（……ピアノが、一瞬だけ鳴った気がした。誰も触っていないのに）',
        duration: 3000,
        oneShot: true,
      },
    ],
  },

  library: {
    id: 'library',
    name: '図書室',
    description: '本が整然と並んだ図書室。埃が積もっているが、一箇所だけ手で拭われた跡がある。',
    floor: 2,
    bgColor: '#1e2a1e',
    bgPattern: 'library',
    bgImage: '/images/図書室.jpg',
    hotspots: [
      {
        id: 'bookshelf_colored',
        x: 5,
        y: 15,
        width: 32,
        height: 75,
        label: '色付きの本棚',
        puzzleId: 'bookshelf_morse',
        description: '本の背表紙が不自然な色の並びになっている。\n赤赤赤青 ― 赤青赤赤 ― 赤赤赤 ― 青青\n4つのグループに分かれているようだ……',
      },
      {
        id: 'library_desk',
        x: 55,
        y: 57,
        width: 23,
        height: 8,
        label: '閲覧机',
        puzzleId: 'diary_misdirect',
        description: '机の上に開かれたままのノートがある。',
      },
      {
        id: 'library_corner',
        x: 75,
        y: 68,
        width: 10,
        height: 22,
        label: '本棚の隅',
        description: '本棚の隅に楽譜の破片が落ちている。',
        itemReward: 'torn_sheet_music_3',
      },
      {
        id: 'library_hidden',
        x: 40,
        y: 72,
        width: 6,
        height: 16,
        label: '本棚の裏',
        description: '本棚の裏に何かが隠されている……日記の一部だ。',
        itemReward: 'diary_fragment_3',
      },
      {
        id: 'library_door',
        x: 88,
        y: 25,
        width: 10,
        height: 50,
        label: '廊下へ',
        targetRoom: 'hallway_2f',
        description: '廊下に戻る。',
      },
    ],
  },

  hallway_3f: {
    id: 'hallway_3f',
    name: '3階 廊下',
    description: '3階の廊下。空気が重い。壁に何かが書かれた跡がある。',
    floor: 3,
    bgColor: '#2a1a1a',
    bgPattern: 'hallway',
    bgImage: '/images/3階廊下.jpg',
    requiredKey: 'floor3_key',
    hotspots: [
      {
        id: 'hw3_to_science',
        x: 2,
        y: 15,
        width: 16,
        height: 65,
        label: '理科室',
        targetRoom: 'science_lab',
        description: '理科室のドア。',
      },
      {
        id: 'hw3_to_art',
        x: 25,
        y: 20,
        width: 13,
        height: 55,
        label: '美術室',
        targetRoom: 'art_room',
        description: '美術室のドア。',
      },
      {
        id: 'hw3_to_rooftop',
        x: 40,
        y: 10,
        width: 20,
        height: 70,
        label: '屋上',
        targetRoom: 'rooftop',
        requiredItem: 'rooftop_key',
        description: '屋上へ続くドア。厳重に施錠されている。',
        interactedDescription: '屋上へ続くドア。鍵は開いている。',
      },
      {
        id: 'hw3_stairs_down',
        x: 75,
        y: 25,
        width: 18,
        height: 60,
        label: '階段（2F）',
        targetRoom: 'hallway_2f',
        description: '2階への階段。',
      },
      {
        id: 'hw3_wall_writing',
        x: 72,
        y: 5,
        width: 25,
        height: 25,
        label: '壁の落書き',
        description: '壁に爪で引っ掻いたような文字。\n「ごめんなさい ごめんなさい ごめんなさい ごめんなさい ごめんなさい」\n同じ言葉が何度も繰り返されている。',
        itemReward: 'diary_fragment_4',
      },
    ],
    horrorEvents: [
      {
        id: 'hw3_heavy_air',
        trigger: 'enter',
        type: 'text',
        content: '（空気が……重い。呼吸が苦しくなるほどの圧迫感を感じる）',
        duration: 4000,
        oneShot: true,
      },
      {
        id: 'hw3_glitch',
        trigger: 'time',
        triggerValue: 15000,
        type: 'screen_effect',
        content: 'glitch',
        duration: 1500,
        oneShot: true,
      },
    ],
  },

  science_lab: {
    id: 'science_lab',
    name: '理科室',
    description: '実験器具が並ぶ理科室。元素周期表が壁に貼られている。',
    floor: 3,
    bgColor: '#1a2a2e',
    bgPattern: 'science',
    bgImage: '/images/理科室.jpg',
    hotspots: [
      {
        id: 'element_table',
        x: 1,
        y: 8,
        width: 25,
        height: 70,
        label: '元素周期表',
        puzzleId: 'element_puzzle',
        description: '壁の元素周期表。いくつかの元素に赤い丸がつけられている。\n丸がついているのは：\nTi（チタン）、Ir（イリジウム）、No（ノーベリウム）\nこの元素記号の読みを日本語にすると……？',
      },
      {
        id: 'science_desk',
        x: 20,
        y: 50,
        width: 35,
        height: 40,
        label: '実験机',
        description: '実験机の上に古いノートが置いてある。\n「元素の名を読め。罪を知れ。そして向き合え。」',
      },
      {
        id: 'science_cabinet',
        x: 60,
        y: 10,
        width: 25,
        height: 65,
        label: '薬品棚',
        description: '薬品棚。ほとんど空だが、奥に何かがある。',
        itemReward: 'diary_fragment_5',
      },
      {
        id: 'science_door',
        x: 88,
        y: 15,
        width: 12,
        height: 70,
        label: '廊下へ',
        targetRoom: 'hallway_3f',
        description: '廊下に戻る。',
      },
    ],
  },

  art_room: {
    id: 'art_room',
    name: '美術室',
    description: 'イーゼルが並ぶ美術室。5枚の絵画がバラバラに壁に掛けられている。',
    floor: 3,
    bgColor: '#2e1a2a',
    bgPattern: 'art',
    bgImage: '/images/美術室.jpg',
    hotspots: [
      {
        id: 'paintings',
        x: 8,
        y: 8,
        width: 58,
        height: 52,
        label: '5枚の絵',
        puzzleId: 'painting_order',
        description: '5枚の絵が壁にバラバラに掛けられている。それぞれ異なる場面が描かれている。\n\n① 廊下で少女と別の人物の目が合う。しかし相手はすぐに視線をそらしている\n② 少女が屋上のフェンス越しに空を見上げている。穏やかな表情\n③ 教室で少女が一人座っている。周りのクラスメイトは全員背を向けている\n④ 少女が暗い教室の隅でうずくまっている。机の上に教科書が散乱している\n⑤ 少女が誰かの背中を見つめている。手を伸ばしかけて、止めている\n\nこれらを正しい時系列順に並べると……',
      },
      {
        id: 'art_easel',
        x: 65,
        y: 25,
        width: 20,
        height: 60,
        label: 'イーゼル',
        description: 'イーゼルの上に未完成の絵。\n二人の人物が描かれている。一人は手を伸ばし、もう一人は背を向けている。\n絵の裏に「あの時、手を掴んでいれば」と書かれている。',
      },
      {
        id: 'art_door',
        x: 88,
        y: 10,
        width: 10,
        height: 70,
        label: '廊下へ',
        targetRoom: 'hallway_3f',
        description: '廊下に戻る。',
      },
    ],
    horrorEvents: [
      {
        id: 'art_painting_change',
        trigger: 'time',
        triggerValue: 30000,
        type: 'text',
        content: '（……絵の中の少女と、一瞬目が合った気がした）',
        duration: 3000,
        oneShot: true,
      },
    ],
  },

  rooftop: {
    id: 'rooftop',
    name: '屋上',
    description: '風が吹きすさぶ屋上。月明かりだけが辺りを照らしている。フェンスの向こうに街の灯りが見える。',
    floor: 4,
    bgColor: '#0a0a1e',
    bgPattern: 'rooftop',
    bgImage: '/images/屋上.jpg',
    requiredKey: 'rooftop_key',
    hotspots: [
      {
        id: 'rooftop_fence',
        x: 3,
        y: 10,
        width: 65,
        height: 50,
        label: 'フェンス',
        puzzleId: 'last_words',
        description: 'フェンスの前に立つと、風の音に混じって声が聞こえる気がする……',
      },
      {
        id: 'rooftop_letter',
        x: 38,
        y: 62,
        width: 15,
        height: 18,
        label: '落ちている封筒',
        puzzleId: 'final_choice',
        description: '地面に封筒が落ちている。宛名には自分の名前が書かれている。',
        itemReward: 'shiori_letter',
      },
      {
        id: 'rooftop_door',
        x: 78,
        y: 20,
        width: 15,
        height: 55,
        label: '戻る',
        targetRoom: 'hallway_3f',
        description: '3階に戻る。',
      },
    ],
    horrorEvents: [
      {
        id: 'rooftop_wind',
        trigger: 'enter',
        type: 'text',
        content: '冷たい風が全身を包む。\nここが……あの場所だ。\n何かを思い出しそうで、思い出せない。',
        duration: 5000,
        oneShot: true,
      },
    ],
  },
};
